import { Common } from "../../foundations/palette.es.js";
const badgeStylesOverride = {
  colorSecondary: {
    color: Common.white.main
  }
};
export {
  badgeStylesOverride
};
//# sourceMappingURL=styles.es.js.map
